<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="92" height="88" viewBox="0 0 92 88">
    <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#FFF"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
        <path id="c" d="M32 50h14v14H32z"/>
        <filter id="b" width="119.3%" height="119.3%" x="-9.6%" y="-9.6%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".35" result="shadowSpreadOuter1"/>
            <feOffset dx="-2" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"/>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0.192136377 0 0 0 0 0.192169905 0 0 0 0 0.192129046 0 0 0 1 0"/>
        </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path fill="url(#a)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125h89.75v85.75H1.125z"/>
        <path stroke="#D90338" stroke-linecap="square" stroke-width="2.5" d="M20.75 28l50.568.5"/>
        <path stroke="#006AC8" stroke-linecap="square" stroke-width="2.5" d="M20.75 56.606l50.568.5"/>
        <g transform="rotate(45 39 57)">
            <use fill="#000" filter="url(#b)" xlink:href="#c"/>
            <use fill="#FFF" stroke="#313131" stroke-width="2.7" xlink:href="#c"/>
        </g>
    </g>
</svg>
